import { createReducer } from 'reduxsauce'
import Types from './types'

// the initial state of this reducer
export const INITIAL_STATE = {
    submissionUuid: ''
	, account: {}
	, contacts: []
    , offer: {}
    , contractStatus: ''
    , currentContactSigned: ''
}

// Get Initial Data
export const getContractReviewInitialData = (state = INITIAL_STATE, action) => {
    return {
        ...state
        , submissionUuid: action.initialData.submissionUuid
        , account: action.initialData.account
        , contacts: action.initialData.contacts
        , offer: action.initialData.offer
        , contractStatus: action.initialData.contractStatus
        , currentContactSigned: action.initialData.currentContactSigned
    }
}

// map our action types to our reducer functions
export const HANDLERS = {
    [Types.GET_CONTRACT_REVIEW_INITIAL_DATA]: getContractReviewInitialData,
}
  
export default createReducer(INITIAL_STATE, HANDLERS)